import GifObject from "../../../../src/mdx/api/schema/gif-object.mdx";
import * as React from 'react';
export default {
  GifObject,
  React
};